// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-ROe41T"};